export default {
  bank: {},
  name: '',
  branchName: '',
  accountType: null,
  accountNumber: ''
}
